(function () {
    'use strict';

    angular.module('sempraWebapp').factory('invoiceNamingEnumFactory', invoiceNamingEnumFactory);

    /** @ngInject */
    function invoiceNamingEnumFactory($translate, sessionData) {

        return namingCheck();

        function namingCheck() {
          var countryCode = localStorage.getItem(sessionData.Keys.COUNTRY_CODE);
          var data;
          switch (countryCode) {
            case 'RS':
              data = {
                name:  $translate.instant('INVOICE'),
                forInvoicing: $translate.instant('FOR_INVOICING'),
                paymentsOnHold: $translate.instant('PAYMENTS_ON_HOLD'),
                invoiceNumber: $translate.instant('INVOICE_NUMBER'),
                invoiceState: $translate.instant('INVOICE_STATE')
              }
              break;

            default:
              data = {
                name: $translate.instant('PAYMENT_REQUEST'),
                forInvoicing: $translate.instant('FOR_PAYMENT_REQUEST'),
                paymentsOnHold: $translate.instant('PAYMENT_REQUEST_ON_HOLD'),
                invoiceNumber: $translate.instant('PAYMENT_REQUEST_NUMBER'),
                invoiceState: $translate.instant('PAYMENT_REQUEST_STATE')
              }
              break;
          }
          return data;
        }

    }
})();
